import styles from './detail-line.module.scss';

type DetailLineProps = {
  label: string;
  value: string;
};

export const DetailLine = ({ label, value }: DetailLineProps) => (
  <p className={styles.line}>
    <span className={styles.label}>{label}: </span>
    <span className={styles.value}>{value}</span>
  </p>
);
